import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import CompanyProductSlider from "@components/Pages/Company/CompanyProductSlider/CompanyProductSlider"
// import HomeBannerOneFree from "@components/Pages/Home/HomeBannerOneFree/HomeBannerOneFree"
import HomeCustomersSection from "@components/Pages/Home/HomeCustomersSection/HomeCustomersSection"
import HomeInformationSection from "@components/Pages/Home/HomeInformationSection/HomeInformationSection"
import HomeNewsSection from "@components/Pages/Home/HomeNewsSection/HomeNewsSection"
import HomeSecuritySection from "@components/Pages/Home/HomeSecuritySection/HomeSecuritySection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import Divider from "@components/WebsiteRevamp/Divider/Divider"
import HomeHeroAnimated from "@components/WebsiteRevamp/Heros/HomeHeroAnimated/HomeHeroAnimated"
import {getPosts} from "@config/modules"
import {getFeaturedHeroPost, orderNewsList} from "@helpers/getHeroBlogContent"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import BlogPosts from "@jsons/blogPosts.json"
import CustomerStories from "@jsons/customerStories.json"
import Logos from "@jsons/customerStoriesLogos.json"
import fronPageData from "@jsons/frontPage.json"

export default function Home(): JSX.Element {
	const pageData = getTranslatedPageData(fronPageData, undefined, true)
	const list = getValueOrThrow(
		pageData.AdvancedSideAsset,
		"No Homepage AdvancedSideAsset",
	)
	const stories = getPosts("CustomerStoriesModule", {data: CustomerStories})
	const logos = getPosts("logosModule", {data: Logos})
	const Posts = getPosts("BlogPostsModule", {data: BlogPosts})

	return (
		<>
			<HeadMeta meta={pageData.metaData} customPath={"/"} />
			<HomeHeroAnimated
				data={getValueOrThrow(
					pageData.heroData,
					"No Homepage heroData",
				)}
				featuredPost={getFeaturedHeroPost(Posts)}
			/>
			<CompanyProductSlider data={list[0]} />
			{/* <HomeBannerOneFree data={list[1]} /> */}
			<HomeSecuritySection data={list[2]} />
			<ContainerWrapper>
				<Divider thickness={"2px"} />
			</ContainerWrapper>
			<HomeCustomersSection
				data={list[3]}
				logos={logos}
				stories={stories}
			/>
			<HomeInformationSection data={list[4]} counts={list[5]} />
			<HomeNewsSection data={list[6]} lastPost={orderNewsList(Posts)} />
		</>
	)
}
